import React, { useContext } from 'react';
import classNames from 'classnames';
import EnterpriseContext from '../../providers/Enterprise/Enterprise.context';
import EnterpiseTeam from 'components/EnterpiseTeam';

import './Team.styles.scss';

type TeamProps = {
  className?: string;
};

const Team: React.FC<TeamProps> = (props) => {
  const { className } = props;

  const classes = classNames('team', className);

  const { enterprise, updateBusinessUnits } = useContext(EnterpriseContext);

  return (
    <EnterpiseTeam
      className={classes}
      enterprise={enterprise}
      updateBusinessUnits={updateBusinessUnits}
    />
  );
};

export default Team;
